export default __webpack_public_path__ + "static/media/Armbands of the Haunter in the Dark.11d48280.jpg";